/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nf_Page_Not_FoundInputs */

const en_nf_page_not_found = /** @type {(inputs: Nf_Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oops, Page not found!`)
};

const ar_nf_page_not_found = /** @type {(inputs: Nf_Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عذرًا، الصفحة غير موجودة!`)
};

const bn_nf_page_not_found = /** @type {(inputs: Nf_Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দুঃখিত, পেজটি মেলেনি!`)
};

const de_nf_page_not_found = /** @type {(inputs: Nf_Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoppla, Seite nicht gefunden!`)
};

const es_nf_page_not_found = /** @type {(inputs: Nf_Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Ups, página no encontrada!`)
};

const fr_nf_page_not_found = /** @type {(inputs: Nf_Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oups, page introuvable !`)
};

const pt_nf_page_not_found = /** @type {(inputs: Nf_Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ops, página não encontrada!`)
};

const zh_nf_page_not_found = /** @type {(inputs: Nf_Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哎呀，找不到页面！`)
};

const tr_nf_page_not_found = /** @type {(inputs: Nf_Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hata, Sayfa bulunamadı!`)
};

const ru_nf_page_not_found = /** @type {(inputs: Nf_Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`К сожалению, страница не найдена!`)
};

const pl_nf_page_not_found = /** @type {(inputs: Nf_Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups, nie znaleziono strony!`)
};

/**
* | output |
* | --- |
* | "Oops, Page not found!" |
*
* @param {Nf_Page_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const nf_page_not_found = /** @type {((inputs?: Nf_Page_Not_FoundInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nf_Page_Not_FoundInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_nf_page_not_found(inputs)
	if (locale === "bn") return bn_nf_page_not_found(inputs)
	if (locale === "de") return de_nf_page_not_found(inputs)
	if (locale === "es") return es_nf_page_not_found(inputs)
	if (locale === "fr") return fr_nf_page_not_found(inputs)
	if (locale === "pt") return pt_nf_page_not_found(inputs)
	if (locale === "zh") return zh_nf_page_not_found(inputs)
	if (locale === "tr") return tr_nf_page_not_found(inputs)
	if (locale === "ru") return ru_nf_page_not_found(inputs)
	if (locale === "pl") return pl_nf_page_not_found(inputs)
	return en_nf_page_not_found(inputs)
});